[
    {
        "category": "EcomMaxisGeneral",
        "value": "Maxis Postpaid",
        "product": "Maxis Postpaid",
        "customerSubtype": "Maxis Individual"
    },
    {
        "category": "EcomHotlinkPostpaidGeneral",
        "value": "Hotlink Postpaid",
        "product": "Hotlink Postpaid",
        "customerSubtype": "Hotlink Individual",
        "familyType": "Flex"
    },
    {
        "category": "EcomHotlinkPrepaidGeneral",
        "value": "Hotlink Prepaid",
        "product": "Hotlink Prepaid",
        "customerSubtype": "Individual"
    },
    {
        "category": "BusGTC",
        "value": "Maxis Postpaid for Business Individual",
        "product": "Maxis Postpaid for Business Individual",
        "customerSubtype": "Maxis Individual",
        "familyType": "MOP"
    },
    {
        "category": "ECOMPRETOPOST",
        "value": "Hotlink PreToPost",
        "product": "Hotlink PreToPost",
        "customerSubtype": "Hotlink Individual",
        "familyType": "Flex"
    }
]